<template lang="pug">
v-container(fluid pa-0 ma-0 class="widget-container  d-flex align-self-stretch  tw-h-full")
  v-row(
    no-gutters
    align="stretch"
    justify="center"
    class=" tw-cursor-pointer tw-flex tw-h-full widget-container"
    @click="edit"
  )
    v-col(class=" tw-w-full tw-h-full tw-p-0 widget-container ")
      v-hover(v-slot="{ hover }")
        div(class="tw-w-full tw-h-full tw-grid tw-grid-cols-12 tw-m-0 widget-container")
          v-fade-transition
            div(
              v-if="hover"
              class=" transition-fast-in-fast-out tw-z-20 tw-col-span-12 tw-h-full tw-align-middle  tw-row-span-full tw-col-start-1 "
            )
              div(class="tw-w-full tw-h-full tw-grid tw-grid-cols-12 tw-m-0 ")
                div(class="tw-z-10 tw-col-span-12 tw-h-full tw-align-middle  tw-row-span-full tw-col-start-1 ")
                  div(class="tw-h-full tw-justify-center tw-items-center  tw-flex ")
                    v-btn(
                      dark
                      :ripple="false"
                      elevation="0"
                      fab
                      color="grey darken-3"
                    )
                      v-icon(dark) mdi-pencil
                div(class=" tw-row-span-full tw-col-start-1 tw-col-span-12 tw-bg-white tw-opacity-25 ")

          div(class=" tw-row-span-full tw-col-start-1 tw-col-span-12")
            div(v-if="content" class="tw-z-0 tw-w-full tw-h-full")
              v-row(no-gutters align="start" justify="center" class="fill-height")
                v-col(cols="10")
                  div(v-dompurify-html="content" class="widget-content")
  //Edit dialog
  v-dialog(
    v-model="editScreen"
    persistent
    no-click-animation
    max-width="65%"
    hide-overlay
    class="tw-ml-32"
  )
    v-card(class="tw-overflow-hidden")
      v-card-text(class="tw-mt-10")
        kubiqa-misc-editor(
          :page="pageContent"
          :gallery="gallery"
          :placement="widget.placement"
          :key="key"
          ref="editor"
          @close="editScreen = false"
          @loading="(status) => (loading = status)"
        )
      v-card-actions(align="right")
        v-row(justify="end")
          v-col(cols="auto")
            v-btn(@click="cancel" :disabled="loading" text color="black") Cancel
          v-col(cols="auto")
            v-btn(depressed @click="save" :loading="loading" color="rgba(94,129,244,0.80)")
              span(class="tw-font-bold") SAVE
</template>

<script>
export default {
  props: {
    page: {
      type: String,
      defalut: null,
    },
    placement: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      editScreen: false,
      loading: false,
      key: 1,
      widget: {
        content: null,
        placement: this.placement,
      },
    };
  },
  watch: {
    content(newContent) {
      this.$emit('content', newContent);
    },
  },
  computed: {
    pageContent() {
      if (typeof this.$store.getters['website/website'].pages !== 'undefined') {
        return this.$store.getters['website/website'].pages[this.page];
      } else {
        return null;
      }
    },
    gallery() {
      if (typeof this.$store.getters['website/website'].gallery !== 'undefined') {
        return this.$store.getters['website/website'].gallery;
      } else {
        return null;
      }
    },
    widgets() {
      if (typeof this.pageContent !== 'undefined' && this.pageContent !== null) {
        return this.pageContent.widgets;
      } else {
        return null;
      }
    },
    content() {
      if (
        typeof this.widgets !== 'undefined' &&
        this.widgets !== null &&
        typeof this.widgets[this.placement] !== 'undefined'
      ) {
        //return this.widgets[this.placement].content;
        return this.$formatters.addImportantToInlineStyles(this.widgets[this.placement].content);
      } else {
        return null;
      }
    },
  },
  mounted() {
    this.widget.content = this.content;
    this.$emit('content', this.content);
  },
  methods: {
    edit() {
      this.key++;
      return (this.editScreen = true);
    },
    cancel() {
      return (this.editScreen = false);
    },
    async save() {
      await this.$refs.editor.save();
      this.$emit('content', this.content);
    },
  },
};
</script>
<style>
.widget-container {
  min-height: 100px !important;
}
.widget-content p {
  margin: 0px !important;
  all: unset !important;
  display: block !important;
}
.widget-content p span {
  all: unset !important;
  display: inline !important;
}
.widget-content p span strong {
  font-weight: revert !important;
  font-size: revert !important;
  display: inline !important;
}
</style>
